import {ElementRef, Injectable, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Router} from '@angular/router';

export interface IAlert {
  title?: string;
  message?: string;
  dismissible?: boolean;
  type: 'success' | 'info' | 'warning' | 'danger';
}

/**
 * Alert message service
 */
@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private alerts$: BehaviorSubject<IAlert[]> = new BehaviorSubject([]);
  readonly alerts = this.alerts$.asObservable();

  constructor(private router: Router) {
    router.events.subscribe((val) => {
      this.clear();
    });
  }

  public addAlert(alert: IAlert, stack: boolean = false) {
    if (stack) {
      this.alerts$.next([alert, ...this.alerts$.getValue()]);
    } else {
      this.alerts$.next([alert]);
    }

    const x = document.getElementById('adminContent');
    x.parentElement.scrollTop = 0;
  }

  public close(alert: IAlert) {
    let updatedAlerts: IAlert[] = this.alerts$.getValue();
    updatedAlerts = updatedAlerts.filter((a) => a !== alert);
    this.alerts$.next(updatedAlerts);
  }

  public clear() {
    this.alerts$.next([]);
  }
}
